import { cn } from "../lib/cn";

interface SparklineProps {
  values: number[];
  width?: number;
  height?: number;
  className?: string;
  fillClassName?: string;
  strokeClassName?: string;
}

export function Sparkline({
  values,
  width = 120,
  height = 32,
  className,
  fillClassName = "fill-accent/15",
  strokeClassName = "stroke-accent",
}: SparklineProps) {
  if (values.length === 0) return null;
  const max = Math.max(...values, 1);
  const step = width / Math.max(values.length - 1, 1);
  const points = values.map((v, i) => {
    const x = i * step;
    const y = height - (v / max) * (height - 2) - 1;
    return [x, y] as const;
  });
  const path = points
    .map(([x, y], i) => (i === 0 ? `M ${x} ${y}` : `L ${x} ${y}`))
    .join(" ");
  const area = `${path} L ${width} ${height} L 0 ${height} Z`;
  return (
    <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" className={cn("w-full h-full", className)}>
      <path d={area} className={fillClassName} />
      <path d={path} fill="none" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" className={strokeClassName} />
    </svg>
  );
}
